<script lang="ts">
  import { defineComponent } from "vue";
  import FicheAbonnementList from '@/generated/fiches/FicheAbonnementList.vue';
  export default defineComponent({
    extends: FicheAbonnementList,
    components: {}
})
</script>
